import {BaseAnalyticsEvent} from "../../../infrastructure/models/analytics/base-analytics-event";

export class NewsWidgetSeeMoreClickEvent extends BaseAnalyticsEvent {
  countryId: Number;
  langId: Number;
  magazineId: Number;
  sportTypeId: Number;


  constructor(params) {
    super('click', 'see-more', 'articles-component');

    this.countryId = params.countryId;
    this.langId = params.langId;
    this.magazineId = params.magazineId;
    this.sportTypeId = params.sportTypeId;

  }

  get properties() {
    const properties = super.properties;

    properties.countryId = this.countryId;
    properties.langId = this.langId;
    properties.magazineId = this.magazineId;
    properties.sportTypeId = this.sportTypeId;

    return properties;
  }
}
